module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/trieste.03a40dc2b838c3331ced922c26d52bec.jpg";